import { general } from './general';

export const number = (data = {}) => general('number', {
  value: `${data.value || ''}`,
});
